import React from 'react'

class SkeletonLoader extends React.PureComponent {
    
    render () {
        var skeletonBackgroundColor = "#3a3939";
        if(window.settings.brand.general && window.settings.brand.general.skeletonColor && window.settings.brand.general.skeletonColor !== "") {
            skeletonBackgroundColor = window.settings.brand.general.skeletonColor
        }
          var style2= {
            "backgroundColor": skeletonBackgroundColor,
            "height":"480px",
            "marginBottom": "10px"
          }
          if(window.innerWidth < 1025) {
            style2= {
                "backgroundColor": skeletonBackgroundColor,
                "height":"450px",
                "marginBottom": "10px"
              }  
          }
          if(window.innerWidth < 700) {
            style2= {
                "backgroundColor": skeletonBackgroundColor,
                "height":"225px",
                "marginBottom": "10px"
              }  
          }
          var style3= {
            "opacity": 1,
            "transform": "translate3d(0px, 0px, 0px)",
            "width": "8610px",
            "height":"288px",
            "display": "flex"
          }
          var style4= {
              "padding":"20px",
              "overflow":"hidden"

          }
          var style5 = {
            "width": "195px",
            "backgroundColor": skeletonBackgroundColor,
            "margin":"0 5px",
            "height": "290px"
          }
          if(window.innerWidth < 700) {
            style5= {
                "width": "135px",
                "backgroundColor": skeletonBackgroundColor,
                "margin":"0 5px",
                "height": "190px"
              }  
          }
          var style7 = {
            "backgroundColor": skeletonBackgroundColor,
            "height":"30px",
            "width": "300px",
            "marginBottom": "10px"
          }
          if(window.innerWidth < 700) {
            style7= {
                "backgroundColor": skeletonBackgroundColor,
                "height":"30px",
                "width": "165px",
                "marginBottom": "10px"
              }  
          }
          var style8 = {
              "marginBottom": "10px",
              "height": "70px",
              "backgroundColor": skeletonBackgroundColor
          }
          if(window.innerWidth < 700) {
            style8= {
                "marginBottom": "10px",
                "height": "50px",
                "backgroundColor": skeletonBackgroundColor
              }  
          }
          var items = {
            "margin": "0"
        }
    return (
    <div style={style4}>
        <div className="ssrmodule" style={style8}>
        </div>
        <div className="ssrmodule" style={style2}></div>
        <div className="module">
            <div className="video-tray portrait">
                <div className="tray-wrapper-common">
                    <div className="BlockTitle-ssr site-color" style={style7}></div>
                </div>
                <div style={items}>
                    <div className="slick-initialized slick-slider">
                        <div className="slick-list">
                            <div className="slick-track" style={style3}>
                                <div data-index="0" className="slick-slide-ssr slick-active" tabIndex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="1" className="slick-slide-ssr slick-active" tabIndex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="2" className="slick-slide-ssr slick-active" tabIndex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="3" className="slick-slide-ssr slick-active" tabIndex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="4" className="slick-slide-ssr slick-active" tabIndex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="5" className="slick-slide-ssr slick-active" tabIndex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="6" className="slick-slide-ssr slick-active" tabIndex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="7" className="slick-slide-ssr slick-active" tabIndex="-1" style={style5}>
                                    <div></div>
                                </div>
                                <div data-index="8" className="slick-slide-ssr" tabIndex="-1" style={style5}>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )}
}

export default SkeletonLoader